<template>
  <div class="topping-list-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'outlets_edit',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.outlets')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'outlet_out_of_stock',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('store.menu_control')}}</router-link>
                  / {{$t('store.topping_out_of_stock_editing')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card class="mb-0">
            <div slot="header">
              <strong class="text-uppercase">
                {{$t('store.topping_out_of_stock_editing')}}
              </strong>
            </div>
            <!-- Start of Filter session -->
            <b-row class="mb-4">
              <b-col xl="12" class="mb-2"><small class="pull-right text-grey">{{ $t('note_change_page_or_filter') }}</small></b-col>
              <b-col xl="12">
                <div class="pull-right">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options"
                      v-bind:selected="filter.selected"
                      position="prepend"
                      v-bind:all="false"
                      v-model="filter.field"
                      prefix="topping">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData" style="min-width: 300px"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData">
                          <i class="fa fa-search"></i>
                          {{$t('common.search')}}
                        </b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </div>
                <div class="pull-right mr-3">
                  <b-input-group v-bind:prepend="$t('topping.active')">
                    <b-form-select v-model="filter.active"
                      v-bind:value="filter.active"
                      :options="status[$session.get('lang') || 'en']"
                      v-bind:placeholder="$t('topping.active')">
                    </b-form-select>
                  </b-input-group>
                </div>
                <div class="pull-right mr-3">
                  <b-input-group v-bind:prepend="$t('common.data_only_lunch')">
                    <b-form-select v-model="filter.only_lunch" v-bind:value="filter.only_lunch"
                      :options="onlyLunchStatus[$session.get('lang') || 'en']"
                      v-bind:placeholder="$t('common.data_only_lunch')">
                    </b-form-select>
                  </b-input-group>
                </div>
                <div class="pull-right mr-3">
                  <b-input-group v-bind:prepend="$t('topping.type')">
                    <b-form-select v-model="filter.type" v-bind:value="filter.type"
                      :options="typeStatus[$session.get('lang') || 'en']"
                      v-bind:placeholder="$t('topping.type')">
                    </b-form-select>
                  </b-input-group>
                </div>
                <div class="pull-right mr-3">
                  <b-input-group v-bind:prepend="$t('topping.special')">
                    <b-form-select v-model="filter.special" v-bind:value="filter.special"
                      :options="specialStatus[$session.get('lang') || 'en']"
                      v-bind:placeholder="$t('topping.special')">
                    </b-form-select>
                  </b-input-group>
                </div>
              </b-col>
            </b-row>
            <!-- End of Filter session -->

            <!-- Start of Data table session -->
            <div class="table-responsive table-has-reason single-data">
              <table class="table table-striped table-hover table-sm table-bordered">
                <thead>
                <tr>
                  <th scope="col"> {{$t('store.exclusion_target')}}</th>
                  <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                    <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type === 'asc' && dataTable.sort.field === item.name"></i>
                    <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type === 'desc' && dataTable.sort.field === item.name"></i>
                    <span v-if="item.label != null">{{$t('topping.'+item.label)}}</span>
                    <span v-if="item.label == null">{{$t('topping.'+item.name)}}</span>
                  </th>
                  <th v-if="isShowReason()" scope="col" class="col-200w"> {{$t('store.reason')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="dataTable.items.length === 0">
                  <td class="text-center" :colspan="dataTable.fields.length + 5">
                    {{$t('message.no_data')}}
                  </td>
                </tr>
                <tr v-for="item in dataTable.items" :key="item.uuid">
                  <td scope="row" class="text-center">
                    <b-form-checkbox class="checkbox-warning" v-model="item.value" value="1" unchecked-value="0" @change="enableSave = true"></b-form-checkbox>
                  </td>
                  <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                    <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                    <span v-if="field.render == null">{{item[field.name]}}</span>
                  </td>
                  <td v-if="isShowReason()" scope="row" :class="{ 'combobox-require': !item.reason_uuid }">
                    <b-form-select v-if="item.value == 1" v-model="item.reason_uuid" :options="reasonOptions[$session.get('lang') || 'en']" @change="enableSave = true">
                    </b-form-select>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- End of Data table session -->

            <!-- Start of paginate session -->
            <b-row class="mt-3">
              <b-col>
                <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage"/>
              </b-col>
              <b-col class="text-left"> {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
              </b-col>
              <b-col col lg="1">
                <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
              </b-col>
            </b-row>
            <!-- Start of paginate session -->
            <div slot="footer">
              <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="() => $router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" :disabled="!enableSave" @click="pushToppingOutOfStock"> {{$t('common.save')}}
                </button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import SelectDropdown from '../../../components/Partials/SelectDropdown'

  export default {
    name: 'OutletToppingOutOfStock',
    components: {
      SelectDropdown,
    },
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    data: function () {
      return {
        languages: this.$store.getters.languages,
        outletConfig: this.$store.getters.config.gms.outlet,
        outletCode: '',
        status: [],
        onlyLunchStatus: [],
        typeStatus: [],
        specialStatus: [],
        filter: {
          options: [],
          active: 1,
          status: '',
          only_lunch: '',
          special: '',
          type: '',
          name: '',
          field: null,
          key: null,
          aggregator_code: '',
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'sku',
              label: 'sku',
              filter: true,
              sort: true,
              render: (data) => {
                return data
              }
            },
            {
              name: 'name',
              label: 'name',
              filter: true,
              sort: true,
              render: (data) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang') || 'en']
              }
            },
          ],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
        reasonOptions: {},
        enableSave: false
      }
    },
    watch: {
      'dataTable.currentPage': function () {
        this.refreshData()
      },
      'dataTable.perPage': function () {
        this.refreshData()
      },
      'filter.active': function () {
        this.refreshData()
      },
      'filter.only_lunch': function () {
        this.refreshData()
      },
      'filter.type': function () {
        this.refreshData()
      },
      'filter.special': function () {
        this.refreshData()
      }
    },
    async created () {
      for (let i in this.dataTable.fields) {
        if (!this.dataTable.fields.hasOwnProperty(i)) continue
        let field = this.dataTable.fields[i].name
        if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter === true) {
          this.filter.options.push(this.dataTable.fields[i])
        }
        if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort === true && this.dataTable.sort.field == null) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }
      this.$Progress.start()
      this.getStatusData()
      let filter = this.$session.get('filter', null)
      if (filter != null && this.$route.query && this.$route.query.rollback) {
        for (let i in filter.filter) {
          if (!filter.filter.hasOwnProperty(i)) continue
          this.filter[i] = filter.filter[i]
        }
        for (let i in filter.dataTable) {
          if (!filter.dataTable.hasOwnProperty(i)) continue
          this.dataTable[i] = filter.dataTable[i]
        }
      }
    },
    mounted () {
      if (this.$route.params.uuid) {
        this.getDataReason()
        this.getStoreInfo(this.$route.params.uuid)
      }
    },
    methods: {
      getStatusData () {
        for (let l in this.languages) {
          const language = this.languages
          this.onlyLunchStatus[language] = [
            {text: this.$t('common.all', language), value: ''},
            {text: this.$t('common.only_lunch', language), value: 1},
            {text: this.$t('common.non_only_lunch', language), value: 0}
          ]
          this.status[language] = [
            {text: this.$t('common.all', language), value: ''},
            {text: this.$t('common.active', language), value: '1'},
            {text: this.$t('common.inactive', language), value: '0'}
          ]
          this.typeStatus[language] = [
            {text: this.$t('common.all', language), value: ''},
            {text: this.$t('topping.type_all', language), value: 0},
            {text: this.$t('topping.type_default', language), value: 1},
            {text: this.$t('topping.type_extra', language), value: 2}
          ]
          this.specialStatus[language] = [
            {text: this.$t('common.all', language), value: ''},
            {text: this.$t('common.yes', language), value: 1},
            {text: this.$t('common.no', language), value: 0}
          ]
        }
      },
      getStoreInfo (uuid) {
        const vm = this
        vm.axios.outlet.getOutletDetail(uuid, response => {
          if (response.status === 200) {
            let data = response.data.data.item
            vm.outletCode = data.code
            vm.refreshData()
          }
        }, error => {
          console.log('error', error)
        })
      },
      getDataReason () {
        const vm = this
        vm.axios.menu.getListReasonStatus(`page=1&limit=500&sort_field=id&sort_type=asc`, response => {
          if (response.status === 200) {
            const data = vm.getValueFromAttr(response, 'data.data.items', [])
            for (let i = 0; i < vm.languages.length; i++) {
              const language = vm.languages[i];
              vm.reasonOptions[language] = [];
              data.forEach(item => {
                vm.reasonOptions[language].push({
                  value: vm.getValueFromAttr(item, `uuid`, null),
                  text: vm.getValueFromAttr(item, `name.${language}`, null),
                  disabled: !vm.getValueFromAttr(item, `active`, false)
                })
              });
            }
          }
        }, error => {
          console.log('error', error)
        })
      },
      refreshData () {
        const vm = this
        const params = {
          page: this.dataTable.currentPage,
          limit: this.dataTable.perPage,
          sort_field: this.dataTable.sort.field,
          sort_type: this.dataTable.sort.type
        }
        if (String(this.filter.active) !== '') {
          params['active'] = this.filter.active
        }
        if (String(this.filter.only_lunch) !== '') {
          params['only_lunch'] = this.filter.only_lunch
        }
        if (String(this.filter.type) !== '') {
          params['type'] = this.filter.type
        }
        if (String(this.filter.special) !== '') {
          params['special'] = this.filter.special
        }
        if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
          params[this.filter.field] = this.filter.key.trim()
        }
        vm.axios.menu.listToppingOutOfStock(this.outletCode, params, function (response) {
          vm.enableSave = false
          const data = response.data.data.items || []
          data.forEach(item => {
            if (item.out_of_stock && item.out_of_stock.uuid) {
              item.value = 1
              item.reason_uuid = item.out_of_stock.reason_uuid || ''
              item.initialValue = 1
            } else {
              item.value = 0
              item.reason_uuid = ''
              item.initialValue = 0
            }
          });
          vm.dataTable.items = data
          vm.dataTable.total = response.data.data.pagination && response.data.data.pagination.total || data.length
          vm.$forceUpdate()
        })
      },
      async pushToppingOutOfStock () {
        const vm = this
        if (!vm.enableSave) {
          return
        }
        if (vm.checkRequireReason()) {
          vm.$toastr.error(vm.$t('message.validate_reason'), vm.$t('message.error'), {})
          return
        }
        const params = this.getParamsOutOfStock()
        if (params.toppings.length === 0) {
          vm.$toastr.error(vm.$t('store.msg_save_out_of_stock'), '', {})
          return
        }
        vm.axios.menu.pushToppingOutOfStock(vm.outletCode, params, function (response) {
          vm.refreshData()
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.update_successful'), {})
        }, function (data) {
          // vm.$toastr.error(vm.$t('message.error'), vm.$t('message.error'), {})
        })
      },
      getParamsOutOfStock () {
        const params = {
          toppings: []
        }
        this.dataTable.items.forEach(element => {
          if (Number(element.initialValue) === 1 || Number(element.value) === 1) {
            const obj = {
              id: element.id,
              uuid: element.uuid,
              sku: element.sku,
              value: Number(element.value),
              reason_uuid: Number(element.value) === 1 ? element.reason_uuid : ''
            }
            params.toppings.push(obj)
          }
        })
        return params
      },
      updateSort (field) {
        for (let i in this.dataTable.fields) {
          if (!this.dataTable.fields.hasOwnProperty(i)) continue
          if (this.dataTable.fields[i].name === field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort === false)) {
            return
          }
        }
        if (this.dataTable.sort.field !== field) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (this.dataTable.sort.type === 'asc') {
            this.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            this.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }
        this.refreshData()
      },
      isShowReason () {
        return this.outletConfig.config && this.outletConfig.config.show_reason || false
      },
      checkRequireReason () {
        for (let i = 0; i < this.dataTable.items.length; i++) {
          const element = this.dataTable.items[i];
          if (Number(element.value) === 1 && !element.reason_uuid) {
            return true
          }
        }
        return false
      }
    }
  }
</script>

<style scoped>
  .topping-list-form .btn-save {
    float: right;
    margin-right: 22px;
  }

  .topping-list-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .col-200w {
    width: 200px !important;
  }

  .combobox-require select {
    border-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/outlets/OutletToppingOutOfStock.vue